module.exports = __webpack_public_path__ + "img/email.dc91c282.svg";